import angular from 'angular';
import inventoryModule from '../inventoryModule.js';

function inventoryService($q, inventoryConstants, assetsService, httpService) {
  'ngInject';

  return {
    getInventoryItems(pagingParameters) {
      return $q(function (resolve, reject) {
        const urlConfig = {
          url: inventoryConstants.urls.getUserInventory
        };

        httpService
          .httpGet(urlConfig, {
            userId: pagingParameters.userId,
            itemsPerPage: pagingParameters.count,
            cursor: pagingParameters.cursor,
            assetTypeId: pagingParameters.assetTypeId,
            placeTab: pagingParameters.placeTab,
            pageNumber: pagingParameters.pageNumber // This is a hack because not everything on the inventory list-json endpoint uses cursor based paging. Ew.
          })
          .then(function (response) {
            const items = response.Data ? response.Data.Items : [];
            angular.forEach(items, assetsService.translateWwwItem);

            resolve({
              nextPageCursor: response.Data && response.Data.nextPageCursor,
              items
            });
          })
          .catch(function (response) {
            reject(response.Data || response.error || '');
          });
      });
    }
  };
}

inventoryModule.factory('inventoryService', inventoryService);
export default inventoryService;
